define(["./nlgSelectionModule",
    "./nlgSelectionView",
    "./nlgSelectionService"
], function () {
});